<script setup lang="ts">
import type { PropertyOnPage } from '@@/shared/property/api-types';

defineProps<{
  similarItems: PropertyOnPage['similarItems']
  titleTag?: 'p' | 'h2' | 'h3'
}>();
</script>

<template>
  <div class="pt-m flex flex-col gap-m">
    <IadTitle
      tag="p"
      :text="$t(`property.common.similar_properties`)"
    />
    <IadScrollable variant="dense">
      <PropertyCardPromo
        v-for="property of similarItems"
        :key="property.propertyListingRef"
        :property="property"
        :title-tag
      />
    </IadScrollable>
  </div>
</template>
